<script lang="jsx">
import { noop } from 'lodash';

export default {
  name: 'PhoneSelectFooter',
  props: {
    disabledSave: Boolean,
    onSave: {
      type: Function,
      default: noop,
    },
    onCancel: {
      type: Function,
      default: noop,
    },
    saveText: {
      type: String,
    },
    cancelText: {
      type: String,
    },
  },
  render() {
    return (
      <div class="phone-number-select__footer">
        <zm-button data-testid="checkout-button-178" onClick={this.onCancel}>
          {this.cancelText || this.$t('common.btn_cancel')}
        </zm-button>
        <zm-button
          data-testid="checkout-button-177"
          type="primary"
          onClick={this.onSave}
          disabled={this.disabledSave}
        >
          {this.saveText || this.$t('common.btn_save')}
        </zm-button>
      </div>
    );
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/scss-utils.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

@include media(mobile) {
  .phone-number-select {
    &__footer {
      .zbo-button {
        height: 40px;
        font-size: 16px;
      }
    }
  }
}
</style>
